import { render, staticRenderFns } from "./Tela.vue?vue&type=template&id=df86a0ac&"
import script from "./Tela.vue?vue&type=script&lang=js&"
export * from "./Tela.vue?vue&type=script&lang=js&"
import style0 from "./Tela.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports